<template>
    <div
        class="map-track-list"
        :style="{ width: isShowTrackList ? '60%' : '30px' }"
    >
        <div class="track-main">
            <div
                class="telescoping"
                @click="isShowTrackList = !isShowTrackList"
            >
                轨迹列表
                <i
                    :class="
                        isShowTrackList
                            ? 'arrow el-icon-arrow-right'
                            : 'arrow el-icon-arrow-left'
                    "
                ></i>
            </div>
            <div class="track-content" v-show="isShowTrackList">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane
                        :label="trackTypeName"
                        name="first"
                    ></el-tab-pane>
                </el-tabs>
                <vxe-table
                    show-overflow
                    :data="positionList"
                    ref="xTable1"
                    height="290"
                >
                    <vxe-column type="seq" title="序号" width="80"></vxe-column>
                    <vxe-column field="trackingDate" title="时间"></vxe-column>
                    <vxe-column
                        field="address"
                        :title="'地点(共' + positionList.length + '条)'"
                    ></vxe-column>
                    <vxe-column
                        field="speed"
                        title="速度(km/h)"
                        width="100"
                    ></vxe-column>
                    <vxe-column
                        field="isAbnormalName"
                        title="是否异常"
                        width="80"
                    ></vxe-column>
                </vxe-table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'waybillMapTrackList',
    data () {
        return {
            isShowTrackList: false, // 是否显示轨迹列表
            activeName: 'first'
        };
    },
    props: {
        trackTypeName: {
            type: String,
            default () {
                return '';
            }
        },
        positionList: {
            type: Array,
            default () {
                return [];
            }
        }
    }
};
</script>

<style lang="less">
.map-track-list {
    position: absolute;
    top: 5%;
    right: 5px;
    z-index: 999;
    height: 350px;
    font-size: 14px;
    background-color: #fff;
    transition: width 0.5s;
    .track-main {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        .telescoping {
            cursor: pointer;
            display: flex;
            align-items: center;
            width: 24px;
            height: 100%;
            padding: 0 5px;
            text-align: center;
            word-wrap: break-word;
            .arrow {
                cursor: pointer;
                position: absolute;
                left: 8px;
                bottom: 5%;
                border-radius: 50%;
                border: 0.5px solid #666;
            }
        }
    }
    .track-content {
        flex: 1;
    }
}
</style>
